import Ajax from "Utils/ajax";
export const getAllParentDefinition = (data) => Ajax.post('admin/getAllParentDefinition',data);
export const getDatabyParent = (data) => Ajax.post('admin/getDatabyParent',data);
export const addDefinition = (data) => Ajax.post('admin/addDefinition',data);
export const addUpdateDefinition = (data) => Ajax.post('admin/addUpdateDefinition',data);
export const getDefinition = (data) => Ajax.post('admin/getDefinition',data);